module.exports = __webpack_public_path__ + "static/img/banner1.b0231c1b.png";